export default __webpack_public_path__ + "previous-icon.svg";